/**
 * Auth validation utilities
 * Centralized validators for email and password
 */

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const PASSWORD_REGEX = /^(?=.*[A-Za-zА-Яа-яЁё])(?=.*\d).{8,}$/;
export const MIN_PASSWORD_LENGTH = 8;

/**
 * Validate email format
 */
export function validateEmail(email: string): boolean {
  if (!email) return false;
  return EMAIL_REGEX.test(email);
}

/**
 * Validate password requirements (min 8 chars, letters and numbers)
 */
export function validatePassword(password: string): boolean {
  if (!password) return false;
  return PASSWORD_REGEX.test(password);
}

/**
 * Check if password meets minimum length
 */
export function validatePasswordLength(password: string): boolean {
  return password.length >= MIN_PASSWORD_LENGTH;
}

/**
 * Error messages for auth validation
 */
export const AUTH_ERRORS = {
  EMAIL_INVALID: 'Проверьте, правильно ли указан email.',
  EMAIL_REQUIRED: 'Введите email',
  PASSWORD_INVALID: 'Минимум 8 символов, буквы и цифры.',
  PASSWORD_REQUIRED: 'Введите пароль',
  PASSWORD_MIN_LENGTH: `Минимум ${MIN_PASSWORD_LENGTH} символов`,
  PASSWORD_LETTERS_NUMBERS: 'Пароль должен содержать буквы и цифры',
  PASSWORD_MISMATCH: 'Пароли не совпадают',
  PASSWORD_CONFIRM_REQUIRED: 'Подтвердите пароль',
} as const;
